<template>
  <div
    class="footer"
    style="
      padding:0 9vw;
    "
  >
    <el-row>
      <el-col :span="8">
        <div style="padding-left: 10%;">
          <el-image :src="logoWhite" class="logo" style="visibility: hidden;"/>
          <div style="text-align: left; display: flex; border-top: 1px solid #283644;">
            <p style="color: #fff;font-size: 14px; color:#647383; font-weight: 100;">
              <p><span style="padding-left: 5px;">联系电话: {{ siteInformation.companyPhone }}</span></p>
              <p><span style="padding-left: 5px;">客服邮箱: kefu@kingchannels.com</span></p>
              <p><span style="padding-left: 5px;">公司邮箱: {{ siteInformation.companyEmail }}</span></p>
              <!-- <p><span style="padding-left: 5px;">公司网址: {{ siteInformation.companyWebsite }}</span></p> -->
              <p><span style="padding-left: 5px;">公司地址: {{ siteInformation.companyAddress }}</span></p>
              <a
                href="https://si.trustutn.org/info?sn=766191120038951288902&certType=1"
                target="_blank"
                style="margin-top: 5vh;width: 18%;padding: 1%;"
              >
                <el-image
                  style="width: 100px"
                  src="https://v.trustutn.org/images/cert/brand_realname_large_img.png"
                  fit="contain"
                >
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
              </a>
            </p>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div style="padding-left: 10%;">
          <h3 style="font-weight: 100; color:#fff;padding-bottom: 1px;">版权所有</h3>
          <div style="text-align: left; display: flex; border-top: 1px solid #283644;">
            <p style="color: #fff;font-size: 14px; color:#647383; font-weight: 100;font-size: 16px;line-height: 30px;">
              <p style="border-bottom: 1px solid #283644;">奥思·微课资源及案例系统</p>
              <a href="https://beian.miit.gov.cn/com/top/sales/#/Integrated/index" target="_blank" style="color: #647383;text-decoration:none">{{ siteInformation.copyrightInformation }} &nbsp; {{ siteInformation.recordNumber }}</a>
              <p style="border-bottom: 1px solid #283644;">京公网安备 11010802033203</p>
            </p>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div style="padding-left: 10%;">
          <h3 style="font-weight: 100; color:#fff;padding-bottom: 1px; visibility: hidden;">相关资质</h3>
          <div style="visibility: hidden;display: flex;flex-wrap: wrap; border-top: 1px solid #283644; padding-right: 50%;padding-top: 20px;">
            <el-image
              style="width: 48%; padding: 1%;cursor: pointer;"
              src="https://zxjq-gx.obs.cn-east-2.myhuaweicloud.com/%E8%BD%AF%E4%BB%B6%E9%80%9A%E5%88%86%E4%BA%AB/%E8%BD%AF%E4%BB%B6%E9%80%9A%E8%AF%81%E4%B9%A6.jpg"
              fit="contain"
              @click="previewImage('https://zxjq-gx.obs.cn-east-2.myhuaweicloud.com/%E8%BD%AF%E4%BB%B6%E9%80%9A%E5%88%86%E4%BA%AB/%E8%BD%AF%E4%BB%B6%E9%80%9A%E8%AF%81%E4%B9%A6.jpg')"
            >
              <template #error>
                <div class="image-slot">
                  <el-icon><icon-picture /></el-icon>
                </div>
              </template>
            </el-image>
            <el-image
              style="width: 48%; padding: 1%;cursor: pointer;"
              src="https://rjt.softtone.cn/static/img/%E5%87%BA%E7%89%88%E7%89%A9%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81.jpg"
              @click="previewImage('https://rjt.softtone.cn/static/img/%E5%87%BA%E7%89%88%E7%89%A9%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81.jpg')"
              fit="contain"
            >
              <template #error>
                <div class="image-slot">
                  <el-icon><icon-picture /></el-icon>
                </div>
              </template>
            </el-image>
            <el-image
              style="width: 48%; padding: 1%"
              src="https://rjt.softtone.cn/static/img/public/official.jpg"
            >
              <template #error>
                <div class="image-slot">
                  <el-icon><icon-picture /></el-icon>
                </div>
              </template>
            </el-image>
            <el-image
              style="width: 48%; padding: 1%"
              src="https://rjt.softtone.cn/static/img/public/Microletter.jpg"
            >
              <template #error>
                <div class="image-slot">
                  <el-icon><icon-picture /></el-icon>
                </div>
              </template>
            </el-image>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { Phone,Message,Discount,Platform  } from "@element-plus/icons-vue";
import {preview} from 'v-preview-image'
import useSiteInformation from "@/stores/siteInformation"
import logoWhite from "@/assets/image/logo3.png";

const siteInformation = useSiteInformation()
const previewImage = (src) =>{
  preview(src)
}
</script>

<style lang="scss" scoped>

.footer{
  background-image: url('../../../assets/image/footer.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: left top;
  height: 400px;
  display: flex;
  align-items: center;
  .logo{
    width: 200px;
    margin-bottom: 20px;
  }
}
:deep(.el-image) {
  width: 150px;
}
span {
  font-size: 14px;
}
p {
  width: 100%;
  // color: #fff;
  text-align: left;
  // display: flex;
  // justify-content: center;
}
</style>
